export default "__VITE_ASSET__ChZ89oux__"